import { useState } from "react";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import { Phone, Mail, Users, StickyNote } from "lucide-react";
import { toast } from "sonner";
import { cn } from "@/lib/utils";

const KINDS = [["call", Phone], ["email", Mail], ["meeting", Users], ["note", StickyNote]];

// Quick "log a touch" + next step on an opportunity.
export function QuickLog({ opp, onDone }) {
  const [kind, setKind] = useState("call");
  const [body, setBody] = useState("");
  const [next, setNext] = useState(opp.next_step || "");
  const [nextDate, setNextDate] = useState(opp.next_step_date || "");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    if (!body.trim()) return; setBusy(true);
    try { await api.post(`/crm/opportunities/${opp.id}/log`, { kind, body, next_step: next || null, next_step_date: nextDate || null }); const { data } = await api.get("/crm/opportunities"); onDone?.(data.find((o) => o.id === opp.id)); setBody(""); toast.success("Logged"); }
    catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  return (
    <div className="mt-4 rounded-xl border p-3 space-y-2" style={{ borderColor: "var(--line)" }} data-testid="opp-quick-log">
      <div className="flex gap-1">{KINDS.map(([k, I]) => <button key={k} onClick={() => setKind(k)} data-testid={`log-kind-${k}`} className={cn("chip capitalize cursor-pointer", kind === k ? "bg-slate-900 text-white border-slate-900" : "border-slate-200 text-slate-600")}><I className="w-3 h-3" />{k}</button>)}</div>
      <Textarea value={body} onChange={(e) => setBody(e.target.value)} placeholder={`What happened on this ${kind}?`} className="min-h-[60px] text-sm" data-testid="log-body" />
      <div className="grid grid-cols-[1fr_140px] gap-2"><Input value={next} onChange={(e) => setNext(e.target.value)} placeholder="Next step (e.g. send proposal)" className="h-8 text-sm" data-testid="log-next" /><Input type="date" value={nextDate} onChange={(e) => setNextDate(e.target.value)} className="h-8 text-sm" data-testid="log-next-date" /></div>
      <div className="flex justify-end"><Button size="sm" className="rounded-full h-7" onClick={save} disabled={busy || !body.trim()} data-testid="log-save">Log {kind}</Button></div>
    </div>);
}
